import React from 'react';
import clsx from 'clsx';

const Items = [
    {
        name: 'Face Mask',
        unit: 'units',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Face covering',
        unit: 'units',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Polycotton fabric',
        unit: 'meters',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Filter for face mask',
        unit: 'units',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Elastic',
        unit: 'meters',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Visors',
        unit: 'units',
        placeholder: 'Quantity',
        type: 'number',
    },
    {
        name: 'Non-perishable food items',
        placeholder: 'Please specify',
        type: 'text',
    },
    {
        name: 'Other',
        placeholder: 'Please specify',
        type: 'text',
    },
];

export const DonationForm = ({ register }) => (
    <section className="form__section">
        <h3 className="form__section__title">Donation Items</h3>
        {Items.map(({ name, unit, placeholder, type }) => (
            <div className="row mb-4" key={name}>
                <div className="col col-12 col-md-4 product-name">
                    <div>{name}</div>
                </div>
                <div className={clsx({ 'col-8': unit, 'col-12': !unit, 'col-md-6': unit, 'col-md-8': !unit }, 'col')}>
                    <input
                        type={type}
                        className="form-control"
                        name={`donations.${name}`}
                        ref={register}
                        placeholder={placeholder}
                    />
                </div>
                {unit && (
                    <div className={clsx('col', 'col-4', 'col-md-2', 'product-name')}>
                        <div>{unit}</div>
                    </div>
                )}
            </div>
        )
        )}
    </section>
);
